module.exports = __webpack_public_path__ + "static/media/Thai-Private.09dbe3d0.svg";